import PropTypes from 'prop-types';
import { Alert, Box, Card, CircularProgress, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../../components/Iconify';

export function LoadingPanel() {
  return (
    <Stack spacing={2}>
      <CircularProgress />
    </Stack>
  );
}

export function EmptyModuleState({ title, description, icon = 'solar:folder-open-bold' }) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2.5 }}>
      <Stack spacing={2} alignItems="center" textAlign="center" sx={{ p: 5 }}>
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            color: 'primary.main',
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
          }}
        >
          <Iconify icon={icon} width={26} height={26} />
        </Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 520 }}>
          {description}
        </Typography>
      </Stack>
    </Card>
  );
}

EmptyModuleState.propTypes = {
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export function SectionError({ message, onRetry }) {
  return (
    <Alert
      severity="error"
      action={
        onRetry ? (
          <LoadingButton color="inherit" size="small" onClick={onRetry}>
            Retry
          </LoadingButton>
        ) : null
      }
      sx={{ borderRadius: 2.5 }}
    >
      {message}
    </Alert>
  );
}

SectionError.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
};
